import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";
import { toast } from "react-toastify";

const deleteAppDocument = async ({ documentId, patientId, notifyUser }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  params.append("patient_id", patientId);
  params.append("notify_user", notifyUser);

  const response = await axios.delete(
    `${__API_URL__}/api/patient/patient/app_documents/${documentId}/?${params.toString()}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useDeleteAppDocumentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteAppDocument,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["patient-app-documents"],
      });
      toast.success("Successfully deleted the app document");
    },
    onError: (error) => {
      console.error("Failed to delete app document:", error);
    },
  });
};

export default useDeleteAppDocumentMutation;
